import {
  Box,
  Button,
  Checkbox,
  Fieldset,
  Flex,
  Grid,
  MultiSelect,
  Select,
  Tabs,
  Text,
  TextInput,
} from "@mantine/core";
import { DateTimePicker } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { IconCalendarMonth, IconCheck, IconX } from "@tabler/icons-react";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { repositoryPos } from "../../../../_base/_const/_constVar";
import { formatToVietnamTz } from "../../../../_base/extension/DateExtension";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { SelectListItemBase } from "../../../../_base/model/_base/SelectListItemBase";
import { MessageResponse } from "../../../../model/MessageResponse";
import {
  tblPromotion,
  tblPromotionCommand,
  tblPromotionItemGiftCommand,
} from "../../../../model/TblPromotion";
import { TblPromotionConditionMultipleModel } from "../../../../model/TblPromotionConditionMultiple";
import { getTblDmEmployeeSelect } from "../../../../service/getSelectApi";
import { validateCreatePromotion } from "../../../../validate/UserCreateModelValidator";
import CustomersV2 from "./Components/SetupPromotionPolicy/CustomersV2";
import OrtherConditions from "./Components/SetupPromotionPolicy/OtherConditions";
import SaleChannel from "./Components/SetupPromotionPolicy/SaleChannel";
import SuperMarket from "./Components/SetupPromotionPolicy/SuperMarket";
import { PromotionalDescriptionV2 } from "./Components/TableItemPromotion/PromotionalDescriptionV2";
import TableItemAddOnPromotion from "./Components/TableItemPromotion/TableItemAddOnPromotion";
import TableItemGiftPromotion from "./Components/TableItemPromotion/TableItemGiftPromotion";
import TableItemPrimaryPromotion from "./Components/TableItemPromotion/TableItemPrimaryPromotion";

const CreatePromotionPolicy = () => {
  const navigate = useNavigate();
  const [effDate, setEffDate] = useState<string>("");
  const [expDate, setExpDate] = useState<string>("");
  const [selectedPolicyType, setSelectedPolicyType] = useState<string>("0");
  const [dataDeletePromotion, setDataDeletePromotion] = useState<
    tblPromotionItemGiftCommand[]
  >([]);
  const [userSelect, setUserSelect] = useState<SelectListItemBase[]>([]);
  const [isMultiConditionMode, setIsMultiConditionMode] =
    useState<boolean>(false);

  const [promotionConditionMultiples, setPromotionConditionMultiples] =
    useState<TblPromotionConditionMultipleModel[]>([]);

  const [handleAtt3, setHandleAtt3] = useState<string>("N");
  const _styleGrid = { base: 12, md: 6, lg: 2 };
  console.log(handleAtt3, "saddasdsadasdsadsa");
  const [listPromotion, setListPromotion] = useState<string[]>([]);
  const dataPaymentMethod = [
    { value: "all", label: "Tất cả" },
    {
      value: "offline",
      label: "Thanh toán khi nhận hàng",
    },
    {
      value: "online",
      label: "Thanh toán bằng chuyển khoản",
    },
    {
      value: "card",
      label: "Thanh toán bằng thẻ quốc tế Visa, Master",
    },
  ];

  const entity: tblPromotion = {
    tblPromotionCommand: {
      id: 0,
      code: null,
      type: "0",
      createDate: null,
      createBy: null,
      stopTriggerRule: null,
      note: null,
      approveDate: null,
      approveBy: null,
      approveStatus: null,
      approveNote: null,
      priority: null,
      checkRewardPoint: null,
      checkNomalPromote: null,
      listPaymentMethod: null,
      listSaleChanel: null,
      checkMixPromote: null,
      attribute1: null,
      attribute2: null,
      attribute3: null,
      attribute4: null,
      attribute5: null,
      attribute6: null,
      attribute7: null,
      attribute8: null,
      attribute9: null,
      attribute10: null,
      attribute11: null,
      attribute12: null,
      attribute13: null,
      attribute14: null,
      attribute15: null,
      listCustGroup: [],
      lisItemPrimary: [],
      listBranch: "",
      ismultiple: false,
      listType: [],
    },

    tblPromotionItemPrimaryCommands: [],
    tblPromotionItemAddOnCommands: [],
    tblPromotionItemGiftCommands: [],
  };

  const form = useForm<tblPromotion>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },
    validate: {},
  });

  const formHeader = useForm<tblPromotionCommand>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity.tblPromotionCommand,
    },
    validate: validateCreatePromotion,
  });

  const backHome = () => {
    navigate("/config-system/config-promotion-policy");
    localStorage.removeItem("policyType");
  };

  const checkAllItemsExist = (arrayCheck: string[]): boolean => {
    const allValuesFromA = dataPaymentMethod
      .filter((item) => item.value !== "all")
      .map((item) => item.value);

    return allValuesFromA.every((value) => arrayCheck.includes(value));
  };

  /*************  ✨ Codeium Command ⭐  *************/
  /**
   * Function to handle the creation of a new promotion
   * @param dataSubmit the data of the promotion to be created
   * @returns {Promise<void>}
   */
  /******  a9b69603-70ea-4a22-8b8f-098b68a55e08  *******/

  const handleCreatePromotion = async (dataSubmit: tblPromotion) => {
    try {
      if (
        !dataSubmit.tblPromotionCommand?.effDate ||
        !dataSubmit.tblPromotionCommand?.expDate
      ) {
        NotificationExtension.Warn("Vui lòng chọn khoảng thời gian hiệu lực !");
        return;
      }

      const data = "/api/v1/TblPromotion/create";
      const dataApi = await repositoryPos.post<MessageResponse<boolean>>(
        data,
        dataSubmit,
      );
      if (dataApi?.httpStatusCode === 200)
        if (dataApi && dataApi.success) {
          NotificationExtension.Success("Thêm mới thành công");
          setTimeout(() => {
            navigate("/config-system/config-promotion-policy");
          }, 2000);
        } else
          NotificationExtension.Fails(dataApi?.message || "Thêm mới thất bại");
    } catch (error) {
      console.log(error);
    }
  };

  const fetchUser = async () => {
    const dataseApi = await getTblDmEmployeeSelect();
    setUserSelect(dataseApi);
  };

  useEffect(() => {
    if (selectedPolicyType) {
      form.setFieldValue("tblPromotionCommand.type", selectedPolicyType);
    }
  }, [selectedPolicyType]);

  useEffect(() => {
    const fetchDataCreatePromotion = async () => {
      const dataApi = await repositoryPos.get<MessageResponse<tblPromotion>>(
        "/api/v1/TblPromotion/create?Prefix=KM",
      );
      if (dataApi && dataApi.success) {
        //  form.setFieldValue("tblPromotionCommand.code", dataApi.data?.tblPromotionCommand.c);
        formHeader.setValues(dataApi.data.tblPromotionCommand);
        formHeader.resetDirty(dataApi.data.tblPromotionCommand);
        formHeader.initialize(dataApi.data.tblPromotionCommand);
        if (dataApi.data.tblPromotionCommand.effDate) {
          formHeader.setFieldValue(
            "effDate",
            new Date(dataApi.data.tblPromotionCommand.effDate),
          );
        }

        formHeader.setFieldValue("listPaymentMethod", ["all"]);
        formHeader.setFieldValue("listSaleChanel", "all");
        formHeader.setFieldValue("attribute3", "1");
      } else {
        NotificationExtension.Fails("Bạn không có quyền thực hiện thao tác");
        navigate("/config-system/config-promotion-policy");
      }
    };

    fetchDataCreatePromotion();
    fetchUser();
    // fetchPromotionCode();
  }, []);

  return (
    <Box
      component="form"
      onSubmit={formHeader.onSubmit(async (e) => {
        if (formHeader.validate().hasErrors) {
          NotificationExtension.Fails("Vui lòng điền đầy đủ thông tin !");
          return;
        }

        // Kiểm tra mô tả khuyến mại: nếu đã nhập nội dung nhưng chưa xác nhận thì chặn lưu
        const moTaTemp = (formHeader as any).getValues()?.moTaTemp ?? "";
        const moTaConfirmed =
          (formHeader as any).getValues()?.moTaConfirmed ?? false;
        if (
          moTaTemp &&
          moTaTemp.replace(/<[^>]*>/g, "").trim().length > 0 &&
          !moTaConfirmed
        ) {
          NotificationExtension.Fails(
            "Vui lòng xác nhận nội dung mô tả khuyến mại trước khi lưu.",
          );
          return;
        }

        let _data = form.getValues();

        if (
          _data &&
          _data.tblPromotionItemPrimaryCommands &&
          _data.tblPromotionItemPrimaryCommands.length > 0 &&
          !_data.tblPromotionItemPrimaryCommands.every(
            (item: any) => item.attribute3 && Number(item.attribute3) > 0,
          )
        ) {
          NotificationExtension.Fails(
            "Vui lòng nhập đầy đủ số lượng áp dụng !",
          );
          return;
        }

        _data.tblPromotionCommand = formHeader.getValues();
        _data.tblPromotionCommand.effDate = formatToVietnamTz(
          _data.tblPromotionCommand.effDate,
        );
        _data.tblPromotionCommand.expDate = formatToVietnamTz(
          _data.tblPromotionCommand.expDate,
        );
        _data.tblPromotionCommand.countDownDate = formatToVietnamTz(
          _data.tblPromotionCommand.countDownDate
            ? new Date(_data.tblPromotionCommand.countDownDate)
            : undefined,
        );
        _data.tblPromotionCommand.listPaymentMethod = Array.isArray(
          _data.tblPromotionCommand.listPaymentMethod,
        )
          ? _data.tblPromotionCommand.listPaymentMethod.join(",")
          : _data.tblPromotionCommand.listPaymentMethod;
        if (listPromotion.length > 0) {
          _data.tblPromotionCommand.ismultiple = listPromotion.length > 0;
          _data.tblPromotionCommand.attribute1 = listPromotion.join(",");
        }
        _data.tblPromotionCommand.attribute6 =
          _data.tblPromotionCommand.type !== "4"
            ? "false"
            : _data.tblPromotionCommand.attribute6;

        if (_data.tblPromotionCommand.type !== "1") {
          _data.tblPromotionItemAddOnCommands = [];
          _data.tblPromotionItemGiftCommands = [];
          _data.tblPromotionItemPrimaryCommands =
            _data.tblPromotionItemPrimaryCommands &&
            Array.isArray(_data.tblPromotionItemPrimaryCommands) &&
            _data.tblPromotionItemPrimaryCommands.length > 0
              ? _data.tblPromotionItemPrimaryCommands.map((item) => ({
                  ...item,
                  discountPercent: null,
                  itemPrimaryName:
                    item.itemPrimaryName && item.itemPrimaryName.length > 100
                      ? String(item.itemPrimaryName).slice(0, 100) + " ..."
                      : item.itemPrimaryName,
                }))
              : [];
        } else {
          _data.tblPromotionItemPrimaryCommands =
            _data.tblPromotionItemPrimaryCommands?.map((item) => ({
              ...item,
              attribute5: null,
              itemPrimaryName:
                item.itemPrimaryName && item.itemPrimaryName.length > 100
                  ? String(item.itemPrimaryName).slice(0, 100) + " ..."
                  : item.itemPrimaryName,
            }));
          _data.tblPromotionItemAddOnCommands =
            _data.tblPromotionItemAddOnCommands &&
            Array.isArray(_data.tblPromotionItemAddOnCommands) &&
            _data.tblPromotionItemAddOnCommands.length > 0
              ? _data.tblPromotionItemAddOnCommands?.map((item) => ({
                  ...item,
                  itemAddOnName:
                    item.itemAddOnName && item.itemAddOnName.length > 100
                      ? String(item.itemAddOnName).slice(0, 100) + " ..."
                      : item.itemAddOnName,
                }))
              : [];
          _data.tblPromotionItemGiftCommands =
            _data.tblPromotionItemGiftCommands &&
            Array.isArray(_data.tblPromotionItemGiftCommands) &&
            _data.tblPromotionItemGiftCommands.length > 0
              ? _data.tblPromotionItemGiftCommands?.map((item) => ({
                  ...item,
                  itemGiftName:
                    item.itemGiftName && item.itemGiftName.length > 100
                      ? String(item.itemGiftName).slice(0, 100) + " ..."
                      : item.itemGiftName,
                  itemPrimaryName:
                    item.itemPrimaryName && item.itemPrimaryName.length > 100
                      ? String(item.itemPrimaryName).slice(0, 100) + " ..."
                      : item.itemPrimaryName,
                }))
              : [];
        }

        // Thêm đoạn này để xử lý attribute4 theo isMultiConditionMode
        if (isMultiConditionMode) {
          _data.tblPromotionCommand.attribute4 = "1";
          _data.promotionConditionMultiples = promotionConditionMultiples; // <-- Gán dữ liệu
          _data.tblPromotionCommand.listBranch = null;
          _data.tblPromotionCommand.listCustGroup = null;
          delete _data.tblPromotionItemAddOnCommands;
          delete _data.tblPromotionItemGiftCommands;
          delete _data.tblPromotionItemPrimaryCommands;
        } else {
          _data.tblPromotionCommand.attribute4 = "";
          delete _data.promotionConditionMultiples;
        }
        await handleCreatePromotion(_data);
      })}
    >
      <Flex
        align={"center"}
        gap={"md"}
        justify={"space-between"}
        px={"3px"}
        wrap={"wrap"}
      >
        <Text size={"16px"} tt={"uppercase"} fw={"bold"}>
          Thêm mới chính sách khuyến mãi
        </Text>
        <Flex gap={"md"}>
          <Button
            type="submit"
            variant="outline"
            color="teal"
            leftSection={<IconCheck size={14} />}
          >
            Lưu chính sách
          </Button>
          <Button
            variant="outline"
            color="red"
            leftSection={<IconX size={14} />}
            onClick={backHome}
          >
            Đóng
          </Button>
        </Flex>
      </Flex>
      <Grid>
        <Grid.Col span={12} h={"max-content"}>
          {/* <GeneralInformation
            selectedPolicyType={selectedPolicyType}
            form={form}
            effDate={effDate}
            setEffDate={setEffDate}
            expDate={expDate}
            setExpDate={setExpDate}
          /> */}

          <Box h={"max-content"}>
            <Fieldset
              legend="Thông tin chung"
              // display={"flex"}
              // style={{ flexDirection: "column", gap: "10px" }}
            >
              <Grid>
                <Grid.Col span={_styleGrid}>
                  <TextInput
                    label="Mã CTKM"
                    placeholder="Nhập Mã CTKM"
                    readOnly
                    withAsterisk
                    key={formHeader.key("code")}
                    {...formHeader.getInputProps("code")}
                  />
                </Grid.Col>
                <Grid.Col span={_styleGrid}>
                  <Select
                    key={formHeader.key("createBy")}
                    label="Người lập"
                    placeholder="Vui lòng chọn..."
                    nothingFoundMessage="Không có dữ liệu"
                    readOnly
                    limit={1}
                    data={userSelect.map((doctype) => ({
                      value: doctype.value,
                      label: doctype.text,
                    }))}
                    searchable
                    withAsterisk
                    {...formHeader.getInputProps("createBy")}
                  />
                </Grid.Col>
                <Grid.Col span={_styleGrid}>
                  <Select
                    label="Chính sách khuyến mãi"
                    placeholder="Vui lòng chọn..."
                    nothingFoundMessage="Không có dữ liệu"
                    data={[
                      ...(formHeader
                        .getValues()
                        .listType?.slice(0, 2)
                        .map((x) => ({
                          value: x.value,
                          label: x.text,
                        })) || []),
                      { label: "Deal sốc", value: "4" },
                    ]}
                    value={formHeader.getValues()?.type}
                    searchable
                    withAsterisk
                    {...formHeader.getInputProps("type")}
                    onChange={(e) => {
                      if (e !== "4") {
                        formHeader.setFieldValue("type", e ? e : "");
                      } else {
                        const effDate = new Date(
                          formHeader.getValues()?.effDate ?? "",
                        );
                        const nextDay = new Date(effDate);
                        nextDay.setDate(effDate.getDate() + 1);
                        nextDay.setHours(0, 0, 0, 0);
                        nextDay.setSeconds(nextDay.getSeconds() - 1);

                        formHeader.setValues((prev) => ({
                          ...prev,
                          type: e ? e : "",
                          expDate: new Date(nextDay),
                        }));
                      }
                    }}
                  />
                </Grid.Col>
                <Grid.Col span={_styleGrid}>
                  <DateTimePicker
                    label="Thời gian bắt đầu đếm ngược"
                    placeholder="Thời gian bắt đầu đếm ngược"
                    minDate={new Date()}
                    locale="vi"
                    rightSection={<IconCalendarMonth size={14} />}
                    clearable
                    key={formHeader.key("countDownDate")}
                    {...formHeader.getInputProps("countDownDate")}
                  />
                </Grid.Col>
                <Grid.Col span={_styleGrid}>
                  <DateTimePicker
                    label="Hiệu lực từ ngày"
                    placeholder="Hiệu lực từ ngày"
                    minDate={new Date()}
                    locale="vi"
                    rightSection={<IconCalendarMonth size={14} />}
                    value={
                      formHeader.getValues()?.effDate
                        ? new Date(formHeader.getValues()?.effDate ?? "")
                        : null
                    }
                    withAsterisk
                    clearable
                    {...formHeader.getInputProps("effDate")}
                    onChange={(e) => {
                      if (formHeader.getValues()?.type !== "4") {
                        formHeader.setFieldValue("effDate", new Date(e ?? ""));
                      } else {
                        const effDate = new Date(e ?? "");
                        const nextDay = new Date(effDate);
                        nextDay.setDate(effDate.getDate() + 1);
                        nextDay.setHours(0, 0, 0, 0);
                        nextDay.setSeconds(nextDay.getSeconds() - 1);

                        formHeader.setValues((prev) => ({
                          ...prev,
                          effDate: new Date(e ?? ""),
                          expDate: new Date(nextDay),
                        }));
                      }
                    }}
                  />
                </Grid.Col>

                <Grid.Col span={_styleGrid}>
                  <DateTimePicker
                    label="Đến ngày"
                    placeholder="Đến ngày"
                    locale="vi"
                    withAsterisk
                    clearable
                    minDate={
                      formHeader.getValues().effDate
                        ? new Date(
                            dayjs(formHeader.getValues().effDate)
                              .add(0, "day")
                              .toDate(),
                          )
                        : new Date()
                    }
                    maxDate={
                      formHeader.getValues()?.type === "4" &&
                      formHeader.getValues().effDate
                        ? (() => {
                            const effDate = new Date(
                              formHeader.getValues().effDate ?? "",
                            );
                            const nextDay = new Date(effDate);
                            nextDay.setDate(effDate.getDate() + 1);
                            nextDay.setHours(0, 0, 0, 0);
                            nextDay.setSeconds(nextDay.getSeconds() - 1);
                            return nextDay;
                          })()
                        : undefined
                    }
                    rightSection={<IconCalendarMonth size={14} />}
                    key={formHeader.key("expDate")}
                    {...formHeader.getInputProps("expDate")}
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
                  <MultiSelect
                    label="Chọn phương thức thanh toán"
                    placeholder="Vui lòng chọn phương thức thanh toán"
                    nothingFoundMessage="Không có dữ liệu"
                    data={dataPaymentMethod}
                    value={
                      formHeader.getValues()?.listPaymentMethod &&
                      Array.isArray(formHeader.getValues()?.listPaymentMethod)
                        ? formHeader.getValues()?.listPaymentMethod
                        : []
                    }
                    searchable
                    {...formHeader.getInputProps("listPaymentMethod")}
                    onChange={(e) => {
                      if (
                        (e?.includes("all") &&
                          e.indexOf("all") === e.length - 1) ||
                        checkAllItemsExist(e)
                      ) {
                        formHeader.setValues((prev) => ({
                          ...prev,
                          listPaymentMethod: ["all"],
                        }));
                      } else if (
                        e?.includes("all") &&
                        e.indexOf("all") === 0 &&
                        e.length > 1
                      ) {
                        formHeader.setValues((prev) => ({
                          ...prev,
                          listPaymentMethod: e
                            ? e.filter((item) => item !== "all")
                            : [],
                        }));
                      } else {
                        formHeader.setValues((prev) => ({
                          ...prev,
                          listPaymentMethod: e ? e : [],
                        }));
                      }
                    }}
                    withAsterisk
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
                  <Select
                    key={formHeader.key("attribute3")}
                    label="Áp dụng"
                    placeholder="Chọn trình duyệt áp dụng"
                    data={[
                      { label: "Áp dụng đồng thời POS và Web", value: "1" },
                      { label: "Chỉ áp dụng trên POS", value: "2" },
                      { label: "Chỉ áp dụng trên Web", value: "3" },
                    ]}
                    withAsterisk
                    {...formHeader.getInputProps("attribute3")}
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 8 }}>
                  <TextInput
                    label="Tên CTKM"
                    placeholder="Tên CTKM"
                    withAsterisk
                    key={formHeader.key("note")}
                    {...formHeader.getInputProps("note")}
                  />
                </Grid.Col>
              </Grid>
              <Grid>
                <Grid.Col span={12}>
                  <TextInput
                    label="Ghi chú"
                    placeholder="Nhập ghi chú"
                    key={formHeader.key("attribute5")}
                    {...formHeader.getInputProps("attribute5")}
                  />
                </Grid.Col>
              </Grid>
              <Grid mt={5}>
                <Grid.Col span={12}>
                  <Flex justify={"start"} align={"center"} gap={"md"}>
                    <Checkbox
                      key={formHeader.key("ismultiple")}
                      label="Áp dụng đồng thời CTKM khác"
                      {...formHeader.getInputProps("ismultiple", {
                        type: "checkbox",
                      })}
                    />
                    {formHeader.getValues()?.type === "4" && (
                      <Checkbox
                        label="Mỗi số điện thoại chỉ được áp dụng 1 lần"
                        checked={formHeader.getValues()?.attribute6 === "true"}
                        onClick={() =>
                          formHeader.setValues((prev) => ({
                            ...prev,
                            attribute6:
                              formHeader.getValues()?.attribute6 &&
                              formHeader.getValues()?.attribute6 === "true"
                                ? "false"
                                : "true",
                          }))
                        }
                      />
                    )}
                  </Flex>
                </Grid.Col>

                {/* <Grid.Col mt={"30px"} span={{ base: 12, md: 6, lg: 3 }}>
                  <Checkbox
                    key={formHeader.key("ismultiple")}
                    label="Áp dụng đồng thời CTKM khác"
                    {...formHeader.getInputProps("ismultiple", {
                      type: "checkbox",
                    })}
                  />
                </Grid.Col> */}

                {/* <Grid.Col span={{ base: 12, md: 8, lg: 8 }}>
                  {listPromotion && (
                    <PillsInput label="Áp dụng đồng thời CTKM khác">
                      <Pill.Group>
                        {listPromotion.map((promotion, index) => (
                          <Pill key={index}>{promotion.trim()}</Pill>
                        ))}
                        <PillsInput.Field placeholder="..." />
                      </Pill.Group>
                    </PillsInput>
                  )}
                </Grid.Col> */}
              </Grid>
            </Fieldset>
          </Box>
        </Grid.Col>

        <Grid.Col span={12}>
          {/* Tabs luôn được render, chỉ ẩn/hiện bằng CSS */}
          <div style={{ display: isMultiConditionMode ? "none" : "block" }}>
            <Tabs
              defaultValue={"primary"}
              styles={{
                tabLabel: { fontWeight: 700, fontSize: 13 },
                panel: {
                  overflowX: "visible",
                },
              }}
            >
              <Tabs.List>
                {/* <Tabs.Tab value="otherConditions">Điều kiện khác</Tabs.Tab> */}
                <Tabs.Tab value="primary">Mặt hàng chính</Tabs.Tab>
                {formHeader.getValues()?.type === "1" ? (
                  <>
                    <Tabs.Tab value="gift">Mặt hàng tặng</Tabs.Tab>
                    <Tabs.Tab
                      disabled={selectedPolicyType === "2"}
                      value="addOn"
                    >
                      Mặt hàng mua kèm
                    </Tabs.Tab>
                  </>
                ) : (
                  <></>
                )}
                <Tabs.Tab value="branch&customer">
                  Chi nhánh áp dụng và khách hàng
                </Tabs.Tab>
                <Tabs.Tab value="PromotionDescription">
                  Mô tả khuyến mãi
                </Tabs.Tab>
                {/* <Tabs.Tab value="time&pay">
        Thời gian và phương thức thanh toán
      </Tabs.Tab> */}
              </Tabs.List>

              <Tabs.Panel value="otherConditions">
                <OrtherConditions />
              </Tabs.Panel>

              <Tabs.Panel value="primary">
                <TableItemPrimaryPromotion
                  form={form}
                  setDeleteData={setDataDeletePromotion}
                  typePromotion={formHeader.getValues()?.type ?? ""}
                />
              </Tabs.Panel>
              <Tabs.Panel value="gift">
                <TableItemGiftPromotion form={form} />
              </Tabs.Panel>
              <Tabs.Panel value="addOn">
                <TableItemAddOnPromotion
                  form={form}
                  setDeleteData={setDataDeletePromotion}
                />
              </Tabs.Panel>
              <Tabs.Panel value="flashSale">
                <TableItemAddOnPromotion
                  form={form}
                  setDeleteData={setDataDeletePromotion}
                />
              </Tabs.Panel>

              <Tabs.Panel value="branch&customer">
                <Grid>
                  <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                    <Fieldset legend={"Chi nhánh áp dụng"} mt={10}>
                      <SuperMarket form={formHeader} />
                    </Fieldset>
                  </Grid.Col>
                  <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                    <Fieldset legend="Đối tượng khách hàng" mt={10}>
                      <CustomersV2 form={formHeader} />
                    </Fieldset>
                  </Grid.Col>
                  <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                    <Fieldset legend={"Kênh bán áp dụng"} mt={10}>
                      <SaleChannel form={formHeader} />
                    </Fieldset>
                  </Grid.Col>
                </Grid>
              </Tabs.Panel>
              <Tabs.Panel value="PromotionDescription">
                <PromotionalDescriptionV2
                  formHeader={formHeader}
                  handleAtt3={handleAtt3}
                />
              </Tabs.Panel>
            </Tabs>
          </div>
        </Grid.Col>
      </Grid>
    </Box>
  );
};

export default CreatePromotionPolicy;
